export default [
  {
    path: '/common/csys/comment/pages/CommentPlugin',
    component: resolve => require(['../pages/comment/CommentPlugin.vue'], resolve),
    title: '评价中心'
  },
];



// WEBPACK FOOTER //
// ./src/content/common/csys/router/CommentPluginRouter.js